import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import logo1 from "../assets/image/darklogo.png";
import { Link } from "react-router-dom";
import "../index.css";

const Footer = () => {
  return (
    <footer className="footer-bg text-white pt-5 pb-4">
      <div className="container-fluid px-md-5 text-center text-md-start">
        <div className="row g-3 d-flex align-items-start"> {/* Added d-flex and align-items-start */}
          
          {/* About Section */}
          <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mb-4 mt-0"> {/* Added mt-0 */}
            <img
              src={logo1}
              alt="Logo"
              width="180"
              className="px-2 rounded mb-1"
              data-aos="fade-right"
              data-aos-once="false"
            />
            <p data-aos="fade-right" data-aos-once="false">
              We provide high-quality AC repair services with professional and experienced technicians.
            </p>
            <div className="d-flex gap-3">
              <a href="#" className="text-white fs-5"><i className="fab fa-facebook"></i></a>
              <a href="#" className="text-white fs-5"><i className="fab fa-twitter"></i></a>
              <a href="#" className="text-white fs-5"><i className="fab fa-instagram"></i></a>
              <a href="#" className="text-white fs-5"><i className="fab fa-linkedin"></i></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
            <h5 className="text-uppercase fw-bold text-white mb-4" data-aos="fade-up" data-aos-once="false">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-3" data-aos="fade-up" data-aos-once="false"><Link to="/" className="text-white text-decoration-none">Home</Link></li>
              <li className="mb-3" data-aos="fade-up" data-aos-once="false"><Link to="/about" className="text-white text-decoration-none">About us</Link></li>
              <li className="mb-3" data-aos="fade-up" data-aos-once="false"><Link to="/services" className="text-white text-decoration-none">Services</Link></li>
              <li className="mb-3" data-aos="fade-up" data-aos-once="false"><Link to="/contact" className="text-white text-decoration-none">Contact</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
            <h5 className="text-uppercase fw-bold text-white mb-4" data-aos="fade-up" data-aos-once="false">Support</h5>
            <ul className="list-unstyled">
              <li className="mb-3" data-aos="fade-up" data-aos-once="false"><Link to="/" className="text-white text-decoration-none">Help Center</Link></li>
              <li className="mb-3" data-aos="fade-up" data-aos-once="false"><Link to="/privacy-policy" className="text-white text-decoration-none">Privacy Policy</Link></li>
              <li className="mb-3" data-aos="fade-up" data-aos-once="false"><Link to="/terms-conditions" className="text-white text-decoration-none">Terms of Conditions</Link></li>
              <li className="mb-3" data-aos="fade-up" data-aos-once="false"><Link to="/Faq" className="text-white text-decoration-none">FAQ</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-4">
            <h5 className="text-uppercase fw-bold text-white mb-4" data-aos="fade-up" data-aos-once="false">Newsletter</h5>
            <p data-aos="fade-up" data-aos-once="false">Subscribe to get latest updates and offers.</p>
            <div className="input-group" data-aos="fade-up" data-aos-once="false">
              <input type="email" className="form-control" placeholder="Enter your email" />
              <button className="btn btn-primary border border-white">Subscribe</button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="text-center py-3 mt-4 border-top border-secondary">
        &copy; VD Elevate Tech Solutions. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
